/**
 * Switches between Category Scores view and Fix Queue view. Behaves as a
 * two-state radio group (only one active at a time). Fix Queue button
 * shows a red-circle badge with the open-issue count when > 0.
 */
export function ViewToggle({ active, onChange, fixCount = 0 }) {
  return (
    <div className="view-toggle" role="tablist" aria-label="Overview mode">
      <button
        type="button"
        role="tab"
        aria-selected={active === 'scores'}
        className={`toggle-btn ${active === 'scores' ? 'active' : 'inactive'}`}
        onClick={() => onChange('scores')}
      >
        Category Scores
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'fixqueue'}
        className={`toggle-btn ${active === 'fixqueue' ? 'active' : 'inactive'}`}
        onClick={() => onChange('fixqueue')}
      >
        {fixCount > 0 && (
          <span className="fix-count" aria-label={`${fixCount} items in fix queue`}>
            {fixCount}
          </span>
        )}
        Fix Queue — Start Here
      </button>
    </div>
  );
}
